import React from 'react';
import nebulaTheme from '@nebula/theme';
import { OffersCardIcon } from '@nebula/icons/ui';
import uiIconSizes from '@nebula/icons/ui/iconSizes';
import CreditLockIcon from '../../../Icons/CreditLockIcon';
import PhoneIcon from '../../../Icons/PhoneIcon';
import ScoreDialIcon from '../../../Icons/ScoreDialIcon';
import { SectionHeading, SectionTitle } from './index.styles';
import type { FeatureSection } from '../../types';

const SECTION_ICONS: Record<string, React.ReactNode> = {
  score: <ScoreDialIcon />,
  security: <CreditLockIcon />,
  support: <PhoneIcon />,
  eligibility: <OffersCardIcon iconSize={uiIconSizes.xSmall} iconColor={nebulaTheme.color.ui.grey[100]} aria-hidden />,
};

interface EntitlementSectionTitleProps {
  section: FeatureSection;
}

const EntitlementSectionTitle: React.FC<EntitlementSectionTitleProps> = ({ section }) => (
  <SectionHeading>
    {SECTION_ICONS[section.id]}
    <SectionTitle role='heading' aria-level={2}>{section.title}</SectionTitle>
  </SectionHeading>
);

export default EntitlementSectionTitle;
